module.exports = __webpack_public_path__ + "static/media/caret-up-space.2d8cdb0a.svg";